module.exports = __webpack_public_path__ + "static/phone-4f16495a75756c7389bf734146dd06c9.png";